var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNormalWN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "normal_w_n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "library",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04a_book_reader_settings_word",
    transform: "translate(-768.000000, -429.000000)",
    fill: "#AAAAAA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M773,429 C775.761424,429 778,431.238576 778,434 L778,444 C778,446.761424 775.761424,449 773,449 C770.238576,449 768,446.761424 768,444 L768,434 C768,431.238576 770.238576,429 773,429 Z M787,429 C789.761424,429 792,431.238576 792,434 L792,444 C792,446.761424 789.761424,449 787,449 C784.238576,449 782,446.761424 782,444 L782,434 C782,431.238576 784.238576,429 787,429 Z",
    id: "normal_w_n"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalWN);
export default __webpack_public_path__ + "static/media/normal_w_n.b6cf638a25e7cb654173fa73ecc0a7ca.svg";
export { ForwardRef as ReactComponent };